<template>
  <div class="header">
    <div class="top">
      <div class="con-box">
        <div class="left">
          <!-- <span>欢迎访问！</span>
					<span class="phone"><img src="../../assets/images/phone.png" alt="">服务热线：xxxx-xxxxxx</span> -->
        </div>
        <div class="right" v-if="currentUser && currentUser.id">
          {{ currentUser.username }}您好，
          <a
            href="https://manage.lwkjfhq.com/zwfw"
            style="color: #1787e0; text-decoration: underline"
            >进入后台</a
          >
          <span style="padding: 0 10px">|</span>
          <span @click="loginout">退出</span>
        </div>
        <div class="right" v-else>
          <a href="https://www.lwkjfhq.com/login.thtml?url=zwfw.lwkjfhq.com"
            >请登录</a
          >
          <!-- <router-link :to="{path: '/login'}">请登录</router-link> -->
          <span style="padding: 0 10px">|</span>
          <a href="https://www.lwkjfhq.com/register.thtml?url=zwfw.lwkjfhq.com"
            >免费注册</a
          >
        </div>
      </div>
    </div>
    <div class="logo">
      <div class="con-box">
        <div class="left">
          <!-- <img src="../../assets/images/logo_icon.png" alt="" style="width: 60px;height: 60px;margin-right: 10px;"> -->
          <img src="../../assets/images/logo.png" alt="" />
        </div>
        <!-- <div class="search">
					<input type="text" placeholder="请输入关键词搜索">
					<div class="btn"><img src="../../assets/images/search_btn.png" alt=""></div>
				</div> -->
      </div>
    </div>
    <div class="nav">
      <div class="con-box">
        <ul>
          <li
            v-for="(item, index) in navList"
            :key="index"
            :class="active == index ? 'active' : ''"
          >
            <div v-if="index !== 1 && index !== 2 && index !== 5">
              <router-link :to="{ path: item.path }">{{
                item.name
              }}</router-link>
              <span></span>
            </div>
            <div v-else-if="index == 2">
              <a href="https://manage.lwkjfhq.com/zwfw">{{ item.name }}</a>
            </div>
            <div v-else-if="index == 5">
              <a href="https://www.lwkjfhq.com">{{ item.name }}</a>
            </div>
            <div v-else>
              {{ item.name }}
              <ol>
                <li
                  v-for="(cell, idx) in item.arr"
                  :key="idx"
                  @click="goweb(cell)"
                  style="cursor: pointer"
                >
                  {{ cell.name }}
                </li>
              </ol>
              <span></span>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div
      class="banner"
      v-if="bannerShow"
      :style="hideScreen ? '' : { height: 214 + 'px' }"
    >
      <div class="con-box">
        <div class="header-search">
          <a-radio-group
            v-model="policyType"
            button-style="solid"
            @change="handleChange"
          >
            <a-radio-button value="file">政策文件</a-radio-button>
            <a-radio-button value="declare">项目申报</a-radio-button>
            <a-radio-button value="read">政策解读</a-radio-button>
          </a-radio-group>
          <div class="header-search-input">
            <a-input-search
              v-model="filterObj.title"
              placeholder="请输入政策关键字进行查询"
              enter-button
              @search="onSearch"
            />
          </div>
          <div class="index-screen" v-if="hideScreen">
            <div class="screen-box">
              <span class="screen-name">发文系统</span>
              <a-radio-group
                v-model="filterObj.SendingSystem"
                button-style="outline"
              >
                <a-radio
                  v-for="item in systemList"
                  :key="item.dictValue"
                  :value="item.dictValue"
                  name="发文系统"
                >
                  {{ item.dictLabel }}
                </a-radio>
              </a-radio-group>
            </div>
            <div class="screen-box">
              <span class="screen-name">政策主题</span>
              <a-radio-group
                v-model="filterObj.policyTheme"
                button-style="solid"
              >
                <a-radio
                  v-for="item in themeList"
                  :key="item.dictValue"
                  :value="item.dictValue"
                  name="政策主题"
                >
                  {{ item.dictLabel }}
                </a-radio>
              </a-radio-group>
            </div>
            <div class="screen-box">
              <span class="screen-name">应用类型</span>
              <a-radio-group
                v-model="filterObj.applicableRange"
                button-style="solid"
              >
                <a-radio
                  v-for="item in appList"
                  :key="item.dictValue"
                  :value="item.dictValue"
                  name="应用类型"
                >
                  {{ item.dictLabel }}
                </a-radio>
              </a-radio-group>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "ant-design-vue";
export default {
  name: "BasicHeader",
  props: {
    currentUser: {
      type: Object,
      default: () => null,
    },
    subType: {
      type: Boolean,
      default: () => false,
    },
  },
  // inject: ['reload'],
  data() {
    return {
      active: 0,
      policyType: "file",
      bannerShow: true,
      hideScreen: true,
      navList: [
        {
          name: "首页",
          type: "index",
          path: "/",
          num: 0,
        },
        {
          name: "政策检索",
          path: "/",
          num: 1,
          arr: [
            {
              name: "政策文件",
              type: "file",
              path: "/file",
            },
            {
              name: "项目申报",
              type: "declare",
              path: "/declare",
            },
            {
              name: "政策解读",
              type: "read",
              path: "/read",
            },
          ],
        },
        {
          name: "政策订阅",
          type: "centerSubscribe",
          path: "/",
          num: 2,
        },
        {
          name: "政策图解",
          type: "maps",
          path: "/diagram",
          num: 3,
        },
        {
          name: "项目申报直达",
          type: "projectApplication",
          path: "/#xmsb",
          num: 4,
        },
        {
          name: "返回总平台",
          type: "back",
          path: "/",
          num: 5,
        },
      ],
      filterObj: {
        title: "",
        policyType: "1",
        SendingSystem: "",
        policyTheme: "",
        applicableRange: "",
      },
      systemList: [],
      themeList: [],
      appList: [],
    };
  },
  created() {
    if (this.$route.path.replace(/\//g, "") == "login") {
      this.bannerShow = false;
    } else {
      this.bannerShow = true;
    }
    this.getActive(this);
    this.systemList = JSON.parse(localStorage.getItem("systemList"));
    this.themeList = JSON.parse(localStorage.getItem("themeList"));
    this.appList = JSON.parse(localStorage.getItem("appList"));

  },
  methods: {
    goweb(cell) {
      this.$router.push({ path: cell.path });
      // console.log(cell.path)
      // this.$emit('@getRefresh')
    },
    getActive(self) {
      let path = self.$route.path;
      for (let i = 0; i < self.navList.length; i++) {
        if (path == self.navList[i].path) {
          self.active = self.navList[i].num;
          break;
        }
      }
    },
    handleChange() {
      if (this.policyType == "file") {
        this.filterObj.policyType = 1;
      } else if (this.policyType == "declare") {
        this.filterObj.policyType = 2;
      } else if (this.policyType == "read") {
        this.filterObj.policyType = 4;
      }
    },
    onSearch() {
      this.$router.push({
        path: "/" + this.policyType,
        query: {
          data: this.filterObj,
        },
      });
      // this.$emit('getRefresh')
    },
    loginout() {
      Modal.confirm({
        title: "信息",
        content: "您确定要注销登录吗？",
        onOk: () => {
          return this.$store.dispatch("Logout").then(() => {
            // this.reload();
            this.$router.go(0);
          });
        },
        onCancel() {},
      });
    },
  },

  watch: {
    $route: {
      handler() {
        if (this.$route.path.replace(/\//g, "") === "login") {
          this.bannerShow = false;
        } else {
          this.bannerShow = true;
        }
        this.getActive(this);

        let path = this.$route.name;
        if (path === "file" || path === "declare" || path === "read") {
          this.hideScreen = false;
        } else {
          this.hideScreen = true;
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.top {
  height: 42px;
  line-height: 42px;
  background-color: #f0f2f7;
  width: 100%;
}

.top .con-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  color: #000;
}

.top .con-box .left .phone {
  padding-left: 50px;
  color: #0075ed;
}

.top .con-box .left .phone img {
  padding-right: 10px;
  margin-top: 10px;
  display: inline-block;
  vertical-align: -3px;
}

.top .con-box .right a {
  color: #000;
}

.logo .con-box {
  height: 126px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo .left {
  height: 46px;
}

.logo .search {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.logo .search input {
  width: 335px;
  height: 40px;
  border-radius: 10px 0 0 10px;
  border: 1px solid #d3d3d3;
  text-indent: 2em;
  font-size: 13px;
}

.logo .search .btn {
  width: 56px;
  height: 40px;
  border-radius: 0 10px 10px 0;
  background-color: #ff9900;
  text-align: center;
}

.nav {
  background: url(../../assets/images/nav_bg.png) no-repeat center 0;
  width: 100%;
  height: 55px;
}

.nav .con-box ul {
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 55px;
  font-size: 18px;
}

.nav .con-box ul li {
  position: relative;
  width: 170px;
  text-align: center;
  color: #fff;
}

.nav .con-box ul li div {
  position: relative;
}

.nav .con-box ul li div ol {
  position: absolute;
  z-index: 999;
  background-color: #0169ec;
  display: none;
}

.nav .con-box ul li div:hover ol {
  display: block;
}

.nav .con-box ul li div ol li:hover {
  background-color: #207dc5;
}

.nav .con-box ul li a {
  color: #fff;
}

.banner {
  height: 410px;
  background: url("../../assets/images/index_banner_bg.jpg") no-repeat center
    top;
}

.banner .header-search {
  padding-top: 50px;
  width: 950px;
  margin: 0 auto;
}

.banner .header-search ul {
  display: flex;
  justify-content: flex-start;
}

.banner .header-search > .ant-radio-group > .ant-radio-button-wrapper {
  width: 120px;
  height: 50px;

  text-align: center;
  line-height: 50px;
  font-size: 17px;
}

.header-search-input {
  height: 50px;
  width: 950px;
  overflow: hidden;
}

/deep/.ant-input-group {
  height: 50px;
}

/deep/.ant-input-group input {
  height: 50px;
  font-size: 18px;
}

/deep/.ant-input-group-addon button {
  height: 50px;
}

/deep/.anticon-search {
  font-size: 25px;
  line-height: 2.3 !important;
}

.index-screen {
  padding-top: 15px;
  width: 950px;
}

.screen-box {
  padding: 0;
  border: none;
  margin-bottom: 10px;
  clear: both;
  overflow: hidden;
}

.screen-name {
  background-color: rgba(225, 225, 225, 0.3);
  color: #fff;
  padding: 5px 10px;
  border-radius: 10px;
  margin-right: 35px;
  font-size: 17px;
  float: left;
}

.ant-radio-group {
  width: 800px;
  float: left;
}

.screen-box .ant-radio-wrapper >>> .ant-radio {
  display: none;
}

.screen-box .ant-radio-wrapper {
  color: #fff;
  line-height: 35px;
  height: 35px;
}

.screen-box /deep/.ant-radio-wrapper-checked {
  color: #1890ff;
}
</style>
